import React from 'react';
import { Link } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import RetrievePayment from './RetrievePayment';

const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY);

const PaymentStatus = () => {
    return (
        <div style={{ float: "left" }}>
            <div class="int-container desktop">
                <img src="/assets/img/int-bg.jpg" alt="" />
            </div>
            <div class="int-container mobile">
                <img src="/assets/img/home-alert-4-mobile.jpg" alt="" />
            </div>
            <div class="main-container">
                <div class="container">
                    <div class="row">
                        <div class="col-md-5 text-center">
                        </div>
                        <div class="col-md-7 text-center">
                            <div class="form-container">
                                <div class="col-md-12 form-group text-center" style={{ paddingTop: '20px' }}>
                                    <Elements stripe={stripePromise}>
                                        <RetrievePayment />
                                    </Elements>
                                </div>
                                <div class="col-md-12 form-group text-center" style={{ paddingTop: '10px' }}>
                                    <Link className="btnAdd" style={{ padding: '5px 10px', float: 'none', margin: '0' }} to="/member-login">Sign-In</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentStatus;